<btn-icon
    [id]="id() + '-action-btn'"
    [icon]="'fa-solid fa-ellipsis-vertical'"
    [outlined]="true"
    [rounded]="true"
    [class]="'custom-action-btn'"
    [disabled]="disabled()"
    (onClick)="onClick.emit($event)"></btn-icon>
